/* eslint-disable @wix/da/create-action-payload-creator */
import { useMemo, useReducer } from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { FolderType } from './redux/types';
import { Action, createAction } from 'redux-actions';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';

type State = {
  selectedGroup?: PapiUser;
  selectedSubmissionType: FolderType;
  filterValue: string;
};

const setSelectedGroup = createAction<PapiUser | undefined>('selectGroup');
const resetSelectedGroup = createAction<void>('resetGroup');
const setFilter = createAction<string>('setFilter');

const initialState = {
  selectedSubmissionType: FolderType.Gallery,
  filterValue: '',
  selectedGroup: undefined,
};

function reducer(prevState: State, action: Action<any>): State {
  switch (action.type) {
    case 'selectGroup':
      return {
        ...prevState,
        selectedGroup: action.payload,
        filterValue: '',
      };
    case 'resetGroup':
      return initialState;
    case 'setFilter':
      return {
        ...prevState,
        filterValue: action.payload,
      };
    default:
      return prevState;
  }
}

export function useAddToGroupFlow() {
  const [{ selectedGroup, selectedSubmissionType, filterValue }, dispatch] = useReducer(
    reducer,
    initialState
  );

  return useMemo(
    () => ({
      selectedGroup,
      selectedSubmissionType,
      filterValue,
      selectGroup: (group: PapiUser) => yieldToMain(() => dispatch(setSelectedGroup(group))),
      resetSelectedGroup: () => yieldToMain(() => dispatch(resetSelectedGroup())),
      onFilterInputChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        yieldToMain(() => dispatch(setFilter(value)));
      },
    }),
    [filterValue, selectedGroup, selectedSubmissionType, dispatch]
  );
}
